// extracted by css-extract-rspack-plugin
export default {"pane":"Conversations-module__pane__ySNaC","wrapper":"Conversations-module__wrapper__Rt04L","layout":"Conversations-module__layout__as5pR"};